const questionTypes = {multipleChoice: 0, openEnded: 1}

const questionSubTypes = {
  numeric: 'numeric',
  totalFaultPercentage: 'total-fault-percentage',
}

export {questionTypes, questionSubTypes}
